require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./kriterien-wochenoeffnungszeiten-oeff-woche-3-6-j-2023-24.json") })
        }
      }, "path---kriterien-wochenoeffnungszeiten-oeff-woche-3-6-j-2023-24");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---kriterien-wochenoeffnungszeiten-oeff-woche-3-6-j-2023-24!./.cache/json/kriterien-wochenoeffnungszeiten-oeff-woche-3-6-j-2023-24.json
// module id = 1143
// module chunks = 231608221292675